import {
	Backdrop,
	createStyles,
	Fade,
	makeStyles,
	Modal,
	Theme,
} from "@material-ui/core";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import styled, { css } from "styled-components";
import Pix from "../../../assets/kinologyIcons/svg/pix.svg";
import { FinancialActions } from "../../../store/ducks/financial";
import { QRCodeSVG } from "qrcode.react";
import { useTranslation } from "react-i18next";
import { Colors } from "../../../styles/colors";

import {ReactComponent as Close} from "../../../assets/kinologyIcons/svg/close.svg";
import { FaturaProps } from "../../../interfaces/cartao.interface";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		modal: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		paper: {
			backgroundColor: theme.palette.background.paper,
			border: "0",
			boxShadow: theme.shadows[5],
		},
	})
);

const ModalPix: React.FC = () => {
	const dispatch = useDispatch();
	const classes = useStyles();
	const { t } = useTranslation();

	const current_language = useSelector(
		(state: any) => state.configs.current_language
	);

	const is_open_modal_pix =  useSelector(
	 	(state: any) => state.financial.modal_pix
	);
	const faturas: FaturaProps[] = useSelector((state: any) => state.financial.faturas);

	const pix = useSelector((state: any) => state.financial.fatura_selecionada);
	const inadimplencia_motivo = useSelector(
		(state: any) => state.configs.config_inadimplencia?.INADIMPLENCIA_MOTIVO
	) as string;

	const ModalClose = () => {
		dispatch(FinancialActions.set_modal_falha_pagamento(true, inadimplencia_motivo))
		dispatch(FinancialActions.set_modal_pix(false, null));
	};

	const formatPrice = (price: number) =>
		(price / 100)?.toFixed(2).replace(/\./g, ",");

	const pixCode = pix?.[pix?.length -1]?.codigo?.toString();

	const qrCode = <QRCodeSVG value={pixCode} size={150} level={"L"}fgColor="#000E4B"  />;

	const handleCopy = () => {
		navigator.clipboard.writeText(pixCode);
		alert(current_language?.codigo_pix_copiado);
		dispatch(FinancialActions.set_modal_pix(false, null));
	};

	return (
		<Modal
			aria-labelledby="transition-modal-title"
			aria-describedby="transition-modal-description"
			className={classes.modal}
			open={is_open_modal_pix}
			closeAfterTransition
			BackdropComponent={Backdrop}
			BackdropProps={{
				timeout: 500,
			}}
		>
			<Fade in={is_open_modal_pix}>
				<ModalContainer>
					<ModalContent>
						<CloseButton onClick={()=> ModalClose()}>
							<Close width={18} height={18} style={{right:5, top:10,  position: 'absolute'}}/>
						</CloseButton>
						<IconContainer>
							<img src={Pix} width="50" height="50" />
						</IconContainer>
						<Title>{current_language?.escolha_pagar_pix}</Title>
						<Title>{current_language?.valor_fatura}</Title>
						<Title>{`R$${formatPrice(
							Number(
								faturas.filter((fat)=>fat.FATURA_TIPO === 'PENDING')[faturas.filter((fat)=>fat.FATURA_TIPO === 'PENDING').length -1]?.FATURA_VALOR?.toString()
							)	
						)}`}</Title>
						<InfoText>{current_language?.codigo_pix_copia_cola}</InfoText>
						<Title
							style={{cursor: 'pointer'}}
							onClick={()=>handleCopy()}
						>
							{pixCode}
						</Title>
						<Button primary onClick={handleCopy}>
							{current_language?.pix_copia_cola}
						</Button>
						<Button secondary onClick={()=>{
								dispatch(FinancialActions.set_modal_pagamento_processado(true, 'pixPayment'))
								dispatch(FinancialActions.set_modal_pix(false, null));
							}}>
							{current_language?.ja_fiz_pagamento}
						</Button>
					</ModalContent>
				</ModalContainer>
			</Fade>
		</Modal>
	);
};

const ModalContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background-color: rgba(0, 0, 0, 0.5);
`;

const ModalContent = styled.div`
	background: white;
	padding: 20px;
	border-radius: 0.75rem;
	max-width: 25%;
	width: 100%;
	text-align: center;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
	position: relative;
`;

const CloseButton = styled.button`
	position: absolute;
	top: 10px;
	right: 10px;
	background: none;
	border: none;
	font-size: 16px;
	cursor: pointer;
`;

const IconContainer = styled.div`
	font-size: 40px;
	color: #00bfa5;
	margin-bottom: 16px;
`;

const Title = styled.h2`
	font-size: 16px;
	color: #002060;
	margin: 0 0 16px;
`;

const InfoText = styled.p`
	font-size: 14px;
	color: #002060;
	margin: 8px 0;
`;

const QRCodeContainer = styled.div`
	margin: 16px 0;
`;

const CodeContainer = styled.div`
	font-size: 14px;
	color: #002060;
	background-color: #f6f6f6;
	padding: 10px;
	border: 1px solid #ccc;
	border-radius: 0.75rem;
	margin-bottom: 16px;
	word-wrap: break-word;
	white-space: pre-wrap;
`;
const Secondary = css`
	border: 1px solid #009973 ;
	background-color: transparent;
	color: ${Colors.neutral_grey_k_70};
`;
const Button = styled.button<ButtonProps>`
	width: 100%;
	padding: 12px;
	font-size: 14px;
	font-weight: bold;
	color: ${({ primary }) => (primary ? "white" : "#009973")};
	background-color: ${({ primary }) => (primary ? "#009973" : "white")};
	border: ${({ primary }) => (primary ? "none" : "1px solid #009973")};
	border-radius: 0.75rem;
	margin-bottom: 8px;
	cursor: pointer;
	&:hover {
		background-color: ${({ primary }) => (primary ? "#009973" : "#f6f6f6")};
	}
	${({secondary})=> secondary && Secondary}
`;

interface ButtonProps {
	primary?: boolean;
	secondary?: boolean;
}

export default ModalPix;
